export enum TaskResult {
	FUND = 1,
	HAS_PLAN = 2,
	PENDING = 3,
	AFP_FOLLOWUP = 4,
	NEW_APPOINTMENT = 5,
	UNFUNDED = 6,
	NOT_INTERESTED = 7,
	NOT_INTERESTED_NO_CALL = 8,
	FPC_FOLLOW_UP = 9,
	RESCHEDULE = 10,
	DO_NOT_CONTACT = 11,
	SEND_INFO = 12,
	CEP_GROUP_APPT = 14,
	CEP_DISCOVERY_APPT = 15,
	CEP_EVENT_RESULTED = 16,
}
